import React from 'react';
import c from 'classnames';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';

import {
  SearchFacetMenuSelect,
  SearchFacets,
} from '@uncinc/react-searchkit';

import { DOMAIN_KVNL, DOMAIN_VNL } from '../../../config/constants';

export interface SearchAllContentFacetsProps {
  className?: string;
}

const SearchAllContentFacets: React.FC<SearchAllContentFacetsProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Facets', className);

  return (
    <SearchFacets className={classNames}>
      <SearchFacetMenuSelect placeholder={t('placeholders.field_theme_name.placeholder')} attribute="theme" />
      {(config.get('CURRENT_DOMAIN') === DOMAIN_VNL) && (
        <SearchFacetMenuSelect placeholder={t('placeholders.field_workfield_name.placeholder')} attribute="workfield" />
      )}

      {(config.get('CURRENT_DOMAIN') === DOMAIN_KVNL) && (
        <>
          <SearchFacetMenuSelect placeholder={t('placeholders.field_phase_of_life_name.placeholder')} attribute="field_phase_of_life_name" />
          <SearchFacetMenuSelect placeholder={t('placeholders.field_locations_name.placeholder')} attribute="field_locations_name" />
        </>
      )}

      <SearchFacetMenuSelect placeholder={t('placeholders.field_combined_types.placeholder')} attribute="combinedTypes" />
      <SearchFacetMenuSelect placeholder={t('placeholders.pillar.placeholder')} attribute="pillar" />
    </SearchFacets>
  );
};

export default SearchAllContentFacets;
